import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { DataTable } from '../../../../design/dataTable/DataTable';
import { IAdminPageProperties } from '../../IAdminPageProperties';
import { StatusValueAdminDomain } from './store/StatusValueAdminDomain'

export interface IStatusValueAdminTableProperties extends IAdminPageProperties { }

export const StatusValueAdminTable = observer(({ layoutDomain }: IStatusValueAdminTableProperties) => {
  const [domain] = useState<StatusValueAdminDomain>(new StatusValueAdminDomain(layoutDomain));
  useEffect(() => {
    layoutDomain.ui.pagePadding.setValue(0)
    return () => layoutDomain.ui.pagePadding.setValue(24)
  }, [])

  return <DataTable dataTableDomain={domain} tableHeight={window.innerHeight} />;
});
